import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
//import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input} from '~/components/Form';


import moment from 'moment';

import { t } from '~/helpers';
import api from '~/services/api';

import { number } from '~/helpers';

import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close }) {

  async function handleSubmit(param) {   
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>

      <S.Wrapper>

        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>

          <Input
            name="fatu_codigo"
            label="Número da Pré-Fatura:"            
            disabled
          />
          <Input
            name="fatu_datahora_geracao"
            label="Data limite para aprovação:"
            value= {data.fatu_datahora_geracao !== null ? moment(data.fatu_datahora_geracao).format('DD/MM/YYYY') : '-'}
            disabled
          />
          <Input
            name="fatu_periodo"
            label="Periodo de Referencia:"
            disabled
          />
          <Input
            name="orga_completo"
            label="Órgão:"
            disabled
          />
          <Input
            name="orga_cgc"
            label="CNPJ:"
            disabled
          />
          <Input
            name="orga_numero_contrato"
            label="Contrato:"
            disabled
          />
          <Input
            name="fatu_endereco_cobranca_completo"
            label="Endereço Cobrança:"
            disabled
          />
          <Input
            name="fatu_numero_empenho"
            label="Empenho:"
            disabled
          />
          <Input
            name="usua_nome_gestor_validacao"
            label="Gestor Aprovação:"
            value={` ${data.usua_nome_gestor_validacao} (${data.usua_email_gestor_validacao}) `}
            disabled
          />
          <Input
            name="fatu_datahora_validacao_gestor_dta"
            label="Data Aprovação:"
            disabled
          />
          <Input
            name="fatu_responsavel_issqn_str"
            label="Retenção de ISSQN:"
            disabled
          />
          <Input
            name="fatu_equipamentos_faturados"
            label="Qtde de dispositivos:"            
            disabled
          />

          <Input
            name="fatu_valor_transacao_moeda"
            label="Valor unitário (R$):"            
            //type="number"
            value={number(data.fatu_valor_transacao_moeda, 2)}
            //serialize = {(value) => number(value, 2)}
            disabled
          />


          <Input
            name="fatu_valor_servico_moeda"
            label="Valor do Serviço (R$):"
            //type="number"
            value={number(data.fatu_valor_servico_moeda, 2)}
            //serialize = {(value) => number(value, 4)}
            disabled
          />


          <Input
            name="fatu_imr"
            label="IMR:"
            //type="number"
            value={number(data.fatu_imr, 2)}
            disabled
          />
          <Input
            name="fatu_aliquota_issqn"
            label="% ISSQN:"
            //type="number"
            value={number(data.fatu_aliquota_issqn, 1)}
            disabled
          />
          <Input
            name="fatu_issqn_retido_moeda"
            label="Valor ISSQN Retido (R$):"
            value={number(data.fatu_issqn_retido_moeda, 2)}
            //type="number"
            disabled
          />
          <Input
            name="fatu_aliquota_ir"
            label="% IRRF:"
            value={number(data.fatu_aliquota_ir, 1)}
            //type="number"
            disabled
          />
          <Input
            name="fatu_ir_retido_moeda"
            label="Valor IRRF a ser retido (R$):"
            value={number(data.fatu_ir_retido_moeda, 2)}
            //type="number"
            disabled
          />          
          <Input
            name="fatu_aliquota_pis"
            label="Aliquota de Pis Retido:"
            value={number(data.fatu_aliquota_pis, 2)}
            //type="number"
            disabled
          />
          <Input
            name="fatu_pis_retido_moeda"
            label="Pis Retido (R$):"
            value={number(data.fatu_pis_retido_moeda, 2)}
            //type="number"
            disabled
          />
          <Input
            name="fatu_aliquota_cofins"
            label="Aliquota Cofins Retido:"
            value={number(data.fatu_aliquota_cofins, 2)}
            //type="number"
            disabled
          />
          <Input
            name="fatu_cofins_retido_moeda"
            label="Cofins Retido (R$):"
            value={number(data.fatu_cofins_retido_moeda, 2)}
            //type="number"
            disabled
          />
          <Input
            name="fatu_aliquota_csll"
            label="Aliquota Csll Retido:"
            //type="number"
            value={number(data.fatu_aliquota_csll, 2)}
            disabled
          />
          <Input
            name="fatu_csll_retido_moeda"            
            label="Csll Retido (R$):"
            value={number(data.fatu_csll_retido_moeda, 2)}
            //type="number"
            disabled
          />
          <Input
            name="fatu_valor_nota_fiscal_moeda"
            label="Valor Nota Fiscal a pagar (R$):"
            value={number(data.fatu_valor_nota_fiscal_moeda, 2)}
            //type="number"
            disabled
          />

        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
